// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

var PFixField = function (fieldId, buffer)
{

    this.FieldId = fieldId;

    if (buffer && buffer !== null)
        this.ReadValue(buffer);
}

PFixField.prototype.ReadValue = function (buffer)
{
    //virtual
};

PFixField.prototype.Write = function (buffer)
{
    //virtual
};

PFixField.prototype.toString = function ()
{
    if (/*this.FieldId === -1 ||*/ this.Value === null)
        return "<empty>";

    return "#" + this.FieldId + "=" + this.Value.toString();
};


PFixField.prototype.SerializeValue = function ()
{
    if (this.Value !== null && this.Value !== undefined)
        return this.Value.toString();
    else
        return "";
}

export { PFixField }